// extracted by mini-css-extract-plugin
export default {"firstRow":"classes_firstRow__e3WDH"};